import React from 'react'

const VCRow = ({ className, children }) => (
  <div className={`row${className?' '+className:''}`}>
    {children}
  </div>
)

export default VCRow



// WEBPACK FOOTER //
// ./src/components/VCRow.js